import { Link } from 'react-router-dom';
import { Container } from '../components/layout/Primitives';

export default function ShippingInfo() {
  return (
    <Container style={{ padding: 'clamp(3rem,8vw,5rem) 1.5rem', maxWidth: '42rem' }}>
      <h1 className="font-display" style={{ fontSize: 'clamp(2rem, 3vw + 1rem, 3rem)', fontWeight: 300 }}>
        Shipping
      </h1>
      <p style={{ lineHeight: 1.75, opacity: 0.78, marginTop: '1.25rem' }}>
        Complimentary standard shipping applies on qualifying orders — final thresholds will match
        your server configuration. Express and international lanes can be surfaced from the same
        source once logistics rules are wired in.
      </p>
      <p style={{ lineHeight: 1.75, opacity: 0.78, marginTop: '1rem' }}>
        At checkout we will calculate taxes and duties automatically per region (placeholder until API
        integration).
      </p>
      <Link to="/contact" style={{ display: 'inline-block', marginTop: '2rem', textDecoration: 'underline' }}>
        Questions? Contact customer care
      </Link>
      <Link to="/" style={{ display: 'block', marginTop: '1rem' }}>
        ← Home
      </Link>
    </Container>
  );
}
